import { post, get, remove, put } from './http';
import { errorHandling } from './error';

const getSiteDocuments = async (id) => {
  try {
    return await get(`order-portal/site/documents/${id}`);
  } catch (err) {
    //   errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const getAllOrders = async (id) => {
  try {
    return await get(`order-portal/sites/${id}/orders`);
  } catch (err) {
    //   errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const getAvailabeKits = async (id) => {
  try {
    return await get(`order-portal/sites/${id}/kits`);
  } catch (err) {
    //   errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const allAddresses = async (id) => {
  try {
    return await get(`order-portal/sites/${id}/address`);
  } catch (err) {
    //   errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};
const allAddresses2 = async (id) => {
  try {
    return await get(`order-portal/sites/${id}/address`);
  } catch (err) {
    //   errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const createAddresses = async (data) => {
  try {
    return await post(`order-portal/address`, data);
  } catch (err) {
    errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const editAddresses = async (id, data) => {
  try {
    return await put(`order-portal/address/${id}`, data);
  } catch (err) {
    errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const deleteAddress = async (id, reason) => {
  try {
    return await remove(`order-portal/address/${id}?changeReason=${reason}`);
  } catch (err) {
    errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const createOrder = async (data) => {
  try {
    return await post(`order-portal/orders`, data);
  } catch (err) {
    errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const getAllCountryList = async (data) => {
  try {
    return await get(`logistic-builder/countries`, data);
  } catch (err) {
    return err?.response?.data;
  }
};

const getCountries = async () => {
  try {
    return await get(`order-portal/countries`);
  } catch (err) {
    return err?.response?.data;
  }
};

const shareOrder = async (id, data) => {
  try {
    return await post(`order-portal/orders/${id}/share`, data);
  } catch (err) {
    errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const orderDetail = async (id, siteId, data) => {
  try {
    return await get(`order-portal/orders/${id}/${siteId}`, data);
  } catch (err) {
    errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const checkSiteForKitsAccess = async (id) => {
  try {
    return await get(`order-portal/sites/${id}/kits/access`);
  } catch (err) {
    errorHandling(err?.response?.data);
    return err?.response?.data;
  }
}

const checkSiteForReportsAccess = async (id) => {
  try {
    return await get(`order-portal/sites/${id}/reports/access`);
  } catch (err) {
    errorHandling(err?.response?.data);
    return err?.response?.data;
  }
}

export {
  editAddresses,
  allAddresses2,
  deleteAddress,
  getAllOrders,
  getAvailabeKits,
  allAddresses,
  createOrder,
  createAddresses,
  getAllCountryList,
  getCountries,
  shareOrder,
  orderDetail,
  getSiteDocuments,
  checkSiteForKitsAccess,
  checkSiteForReportsAccess
};
